import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectCurrentUser, selectCurrentActiveRoles } from 'features'
import { getRoutePath } from 'routes/routes'
import { useActiveRole } from 'hooks'
import { Error401 } from 'pages/errors'

/**
 * User data is stored after 2fa authentication
 * If user is not authenticated, redirect to login page
 * Guard instances can be added to each route in the route object with different roles
 * code to delete user from store on sesion expire will be added later
 * @param {Array of Strings} allowedRoles - roles allowed to access the page
 * @returns
 */
function Guard(_props) {
  const { allowedRoles = [] } = _props
  const user = useSelector(selectCurrentUser)
  const activeRoles = useSelector(selectCurrentActiveRoles)
  const [,{roleHasAccess}] = useActiveRole()
  /**
   * check if user data is in state otherwise redirect to login page
   */
  if (!user) {
    return <Navigate to={getRoutePath('signin')} replace />
  }

  if (!roleHasAccess([...allowedRoles])) {
    return <Error401 activeRole={activeRoles[0]} />
  }

  return _props.children
}

export default Guard
